import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { setCredentials } from "../auth/authSlice";
import { useDispatch } from "react-redux";
import { useNewRefreshTokenMutation } from "../auth/authApiSlice";

export default function EmbedAuth() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const embedString = searchParams.get("embedString");
  const workbookid = searchParams.get("workbookid");
  const sheetid = searchParams.get("sheetid");
  const isEmbed = searchParams.get("isEmbed") === "true";
  const [
    newRefreshToken,
    {
      data: newRefreshTokenData,
      isError: isNewRefreshTokenError,
      isLoading: isNewRefreshTokenLoading,
      isSuccess: isNewRefreshTokenSuccess,
      error: newRefreshTokenError,
    },
  ] = useNewRefreshTokenMutation();
  useEffect(() => {
    if (embedString) {
      const body = {
        embedString
      };
      // console.log(body);
      newRefreshToken(body);
    }
  }, []);

  useEffect(() => {
    if (isNewRefreshTokenSuccess && newRefreshTokenData) {
      // console.log(newRefreshTokenData?.newEmbedToken);
      dispatch(
        setCredentials({
          embededToken: newRefreshTokenData.newEmbedToken,
          isEmbed: true,
        })
      );
      navigate(
        `/dashboard?workbookid=${workbookid}&sheetid=${sheetid}&isEmbed=${isEmbed}`,
        { replace: true }
      );
    }
  }, [isNewRefreshTokenSuccess, newRefreshTokenData, dispatch, navigate]);

  if (isNewRefreshTokenLoading) return <div>Loading...</div>;

  if (isNewRefreshTokenError) {
    console.error(newRefreshTokenError);
    const errorMessage =
      newRefreshTokenError?.data?.message ||
      newRefreshTokenError?.data ||
      undefined;
    return (
      <div className="text-red-600 font-medium">
        Error:
        {errorMessage}
      </div>
    );
  }
}
